
(function() {
    var DEFAULT_THRESHOLD = 0.5;

    var isMobile = document.documentElement.offsetWidth < 768;


    function getOffsetTop(elem) {
        var offsetTop = 0;
        do {
            if ( !isNaN( elem.offsetTop ) )
            {
                offsetTop += elem.offsetTop;
            }
            } while( elem = elem.offsetParent );
        return offsetTop;
    }

    function loadBackgroundImage(src, elementNeedingBackgroundImage) {
        var image = new Image();
        image.classList.add('lazy-background-image');
        image.onload = function(image, elementNeedingBackgroundImage) {
            var backgroundImageElement = document.createElement('div');
            backgroundImageElement.classList.add('lazy-background-image-container');
            if ( "decode" in image ) {
                image.decode().then(function() {
                    backgroundImageElement.style.backgroundImage = "url(" + image.src + ")";
                });
            } else {
                backgroundImageElement.style.backgroundImage = "url(" + image.src + ")";
            }
            elementNeedingBackgroundImage.appendChild(backgroundImageElement);
            setTimeout( function(backgroundImageElement) {
                requestAnimationFrame( function(backgroundImageElement) {
                    backgroundImageElement.classList.add('active')
                }.bind(null, backgroundImageElement));
            }.bind(null, backgroundImageElement), 16);
        }.bind(null, image, elementNeedingBackgroundImage);
        image.src = src;
    }

    function checkCookie(cookieName, value) { 
        var cookieExistsWithValue = 
            document.cookie.split(';') // Array of all cookies
            .filter( function(item) { 
                return item.indexOf(cookieName + '=' + value) >= 0; }
            ) // Array of all cookies that are cookieName + '=' + value
            .length > 0; // Count of all cookies that are cookieName + '=' + value
        
        return cookieExistsWithValue;
    }

    function prefersReducedMotion(){
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || checkCookie('prefers-reduced-motion', 'reduce')) {
            // Handle JavaScript differently
            console.log('this user prefers reduced motion');
            return true;
        }
        return false;
    }
    
    function initializeObservers(selector, prefersReducedMotion) {
        requestAnimationFrame(function() {
            var observers = [];
            var elementsByThreshold = {};
            var elementsByMargin = [];
            var videoElements = document.querySelectorAll('[data-video-observer]');
            var observedElements = document.querySelectorAll(selector);

            // console.log('prefersReducedMotion ' + prefersReducedMotion);

            if ( typeof window.IntersectionObserver == "function" && !prefersReducedMotion){
                for ( var i = 0; i < observedElements.length; i++ ) {
                    var observedElement = observedElements[i];
                    var threshold = observedElement.getAttribute('data-observer-threshold');
                    threshold = threshold ? threshold : DEFAULT_THRESHOLD;
                    if ( !elementsByThreshold.hasOwnProperty(threshold) ) {
                        elementsByThreshold[threshold] = [];
                    }
                    if ( getOffsetTop(observedElement) > (window.pageYOffset + window.innerHeight) || observedElement.hasAttribute('data-observer-always') || observedElement.hasAttribute('data-observer-show') || observedElement.hasAttribute('data-video-observer')) {
                        if ( observedElement.hasAttribute('data-intersection-lazy') ) {
                            elementsByMargin.push(observedElement);
                        } else {
                            elementsByThreshold[threshold].push(observedElement);
                        }
                    } else {
                        observedElement.classList.remove('intersection-observed');
                        if (observedElement.hasAttribute('data-intersection-lazy') ) {
                            if ( observedElement.hasAttribute('data-intersection-src') ) {
                                observedElement.src = observedElement.getAttribute('data-intersection-src');
                            } else if ( observedElement.hasAttribute('data-intersection-background-src') ) {
                                loadBackgroundImage(observedElement.getAttribute('data-intersection-background-src'), observedElement);
                            }
                        }
                    }
                }
            
                var thresholds = Object.keys(elementsByThreshold);
                for ( var i = 0; i < thresholds.length; i++ ) {
                    var threshold = thresholds[i];
                    var options = {
                        threshold : parseFloat(threshold)
                    };
                    var observer = new IntersectionObserver(handleObservation, options);
                    for ( var j = 0; j < elementsByThreshold[threshold].length; j++ ) {
                        observer.observe(elementsByThreshold[threshold][j]);
                    }
                    observers.push(observer);
                }

                var options = {
                    threshold : 0.1,
                    rootMargin : '0px 0px ' + window.innerHeight * 2 + 'px 0px'
                };
                var marginObserver = new IntersectionObserver(handleObservation, options);
                for ( var i = 0; i < elementsByMargin.length; i++ ) {
                    marginObserver.observe(elementsByMargin[i]);
                }
                observers.push(marginObserver);


                var videoObserverOptions = {
                    threshold : 0.1,
                    rootMargin : '0px 0px ' + window.innerHeight * 2 + 'px 0px'
                };
                var videoLoadObserver = new IntersectionObserver(handleVideoObservation, videoObserverOptions);
                for ( var i = 0; i < videoElements.length; i++ ) {
                    var observedElement = videoElements[i];
                    if ( getOffsetTop(observedElement) > (window.pageYOffset + window.innerHeight) ) {
                        console.log("Observing");
                        videoLoadObserver.observe(observedElement);
                    } else {
                        window.pd.video.loadPlayer(observedElement);
                    }
                }
                observers.push(videoLoadObserver);

                document.querySelector('body').classList.add('observable');
            } else {
                document.querySelector('body').classList.add('no-animation');
                document.querySelector('html').classList.add('no-splash-page');
                var observedElements = document.querySelectorAll(selector);
                for ( var i = 0; i < observedElements.length; i++ ) {
                    var observedElement = observedElements[i];
                    if (observedElement.hasAttribute('data-intersection-lazy') ) {
                        if ( observedElement.hasAttribute('data-intersection-src') ) {
                            observedElement.src = observedElement.getAttribute('data-intersection-src');
                        } else if ( observedElement.hasAttribute('data-intersection-background-src') ) {
                            loadBackgroundImage(observedElement.getAttribute('data-intersection-background-src'), observedElement);
                        }
                    }
                }
            }
        }.bind(this));
    };

    function withinThreshold(intersectionRatio, targetRatio) {

    }

    function handleVideoObservation(entries, observer) {
        var activeGroups = {};
        var entryThreshold = 0.1;
        entries.forEach( function(entry) {
            if ( entry.intersectionRatio >= (parseFloat(entryThreshold) - 0.001) ) {
                window.pd.video.loadPlayer(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }
    
    function handleObservation(entries, observer) {
        requestAnimationFrame(function(){
        var activeGroups = {};
        entries.forEach( function(entry) {
                var entryThreshold = entry.target.hasAttribute('data-observer-threshold') ? entry.target.getAttribute('data-observer-threshold') : entry.target.hasAttribute('data-intersection-lazy') ? 0.1 : DEFAULT_THRESHOLD;
                if ( !entry.target.classList.contains('active') && entry.intersectionRatio >= (parseFloat(entryThreshold) - 0.001) ) {
                    var entryGroup = entry.target.getAttribute('data-observer-group');
                    if ( entryGroup && !isMobile ) {
                        if ( !activeGroups.hasOwnProperty(entryGroup) ) {
                            activeGroups[entryGroup] = true;
                        }
                    } else {
                        entry.target.classList.add('active');
                        if ( entry.target.hasAttribute('data-observer-target') && entry.target.hasAttribute('data-observer-target-class') ) {
                            var selector = entry.target.getAttribute('data-observer-target');
                            var targetElement = document.querySelector(selector);
                            targetElement.classList.add(entry.target.getAttribute('data-observer-target-class'));
                        }
                        if ( entry.target.hasAttribute('data-video-observer') ) {
                            window.pd.video.playPlayer(entry.target);
                        }
                        if ( entry.target.hasAttribute('data-intersection-src') ) {
                            requestAnimationFrame(function(){
                                var lazyImage = entry.target.cloneNode();
                                lazyImage.src = entry.target.getAttribute('data-intersection-src');
                                if ( "decode" in lazyImage ) {
                                    lazyImage.decode().then(function() {
                                        entry.target.replaceWith(lazyImage);
                                    })
                                } else {
                                    entry.target.src = entry.target.getAttribute('data-intersection-src');
                                }
                                observer.unobserve(entry.target);
                            }.bind(this));
                        } else if ( entry.target.hasAttribute('data-intersection-background-src') ) {
                            requestAnimationFrame(function(){
                                loadBackgroundImage(entry.target.getAttribute('data-intersection-background-src'), entry.target);
                                observer.unobserve(entry.target);
                            }.bind(this));
                        }
                    }
                } else {
                    if ( entry.intersectionRatio < (parseFloat(entryThreshold) - 0.001) && entry.target.hasAttribute('data-observer-always')  ) {
                        entry.target.classList.remove('active');
                        if ( entry.target.hasAttribute('data-observer-target') && entry.target.hasAttribute('data-observer-target-class') ) {
                            var selector = entry.target.getAttribute('data-observer-target');
                            var targetElement = document.querySelector(selector);
                            targetElement.classList.remove(entry.target.getAttribute('data-observer-target-class'));
                        }
                        if ( entry.target.hasAttribute('data-video-observer') ) {
                            window.pd.video.pausePlayers(entry.target);
                        }
                    }
                }
        });
        var activeGroupKeys = Object.keys(activeGroups);
        for ( var groupKeyIndex = 0; groupKeyIndex < activeGroupKeys.length; groupKeyIndex++ ) {
            var currentGroupKey = activeGroupKeys[groupKeyIndex];
            var groupElements = document.querySelectorAll("[data-observer-group=" + currentGroupKey + "]");
            for (var groupElementIndex = 0; groupElementIndex < groupElements.length; groupElementIndex++) {
                const element = groupElements[groupElementIndex];
                setTimeout(function() {
                    element.classList.add('active');
                }, 150 * groupElementIndex); 
            }
        }
        }.bind(this));
    };
    
    document.addEventListener("DOMContentLoaded", function() {
        var useReduced = prefersReducedMotion();
        initializeObservers('.intersection-observed', useReduced);
    })
})();